import FizConfig from "../FizConfig.ts";
import * as Html from "../util/Html.ts";
import * as Locale from "../util/Locale.ts";
import {searchCallback} from "../lib/giphyapi.js";
import * as progressbar from "../util/progressbar.ts";
import TPL_postgiflist from "../form/post-gif-list.mustache";

export {initDom}
Html.registerWidget('widget/giphy',{initDom:initDom})

Html.registerDom({
  pickgif(url, preview){
    const form = this.closest("form") as HTMLFormElement;
    const giphyPreview = form.querySelector("[data-widget='widget/giphy-preview']") as HTMLElement;
    const textarea = form.querySelector("textarea") as HTMLTextAreaElement;

    if(giphyPreview){
      const event = new CustomEvent("change", {detail: {url, preview}});
      giphyPreview.dispatchEvent(event);
    }else{
      textarea.value = url;
      form.dispatchEvent(new Event('submit'));
    }
    return true;
  }
})
var
  lastSearch = '',
  lastResponse = null;

// Type for column with height tracking
type GifColumn = any[] & { height?: number; shortest?: boolean };

function dispatch(gifs){
  var cols: GifColumn[] = [[],[]];
  cols.forEach(function(column){
    column.height=0;
  })
  gifs.forEach(function(gif){
    var col = cols[0].height<cols[1].height?cols[0]:cols[1];
    col.push(gif);
    col.height = col.height+gif.image.height + 6;
    //preload in good order
    (new Image()).src=gif.image.url;

  });
  var shortCol = cols[0].height<cols[1].height?cols[0]:cols[1];
  shortCol.shortest = true;
  return cols;
}

function search(node: HTMLElement, q: string){
  lastSearch = q;
  const targetNode = node.querySelector('.giphy-img') as HTMLElement;
  const pg = progressbar.standard;
  searchCallback(function(response){
    lastResponse = response;

    var
      gifs = response.data,
      cols = dispatch(gifs);

    if(gifs.length){
      Html.setHtml(targetNode,TPL_postgiflist,{gif:gifs,column:cols});
    }
    pg.close()

  },
  function(){pg.close()},
  q,
  FizConfig.GIPHY_API_KEY,Locale.get().substring(0,2).toUpperCase())
}

var timeout;
function searchlimiter(node: HTMLElement, q: string){
  clearTimeout(timeout);
  timeout = setTimeout(function(){
    if(q!=lastSearch){
      search(node,q)
    }
  },350);
}

function nextlimiter(node: HTMLElement){
  const targetNode = node.querySelector('.giphy-img') as HTMLElement;
  clearTimeout(timeout);
  timeout = setTimeout(function(){
    lastResponse.next(function(response){
      lastResponse.data = lastResponse.data.concat(response.data);
      lastResponse.next = response.next;

      var
        gifs = lastResponse.data,
        cols = dispatch(gifs);

      if(gifs.length){
        Html.setHtml(targetNode,TPL_postgiflist,{gif:gifs,column:cols});
      }

    });
  },350);
}

function initDom(obj: HTMLElement){
  const form = obj.querySelector('form') as HTMLFormElement;
  const input = obj.querySelector('input') as HTMLInputElement;

  // Handle form submit and click
  if(form){
    const formHandler = (evt: Event) => {
      evt.stopPropagation();
      evt.preventDefault();
    };
    form.addEventListener('submit', formHandler);
    form.addEventListener('click', formHandler);
  }

  // Handle input events
  if(input){
    const keyHandler = (evt: KeyboardEvent) => {
      evt.stopPropagation();
      if(evt.which === 13){
        evt.preventDefault();
      }
      searchlimiter(obj, (evt.target as HTMLInputElement).value);
    };

    const changeHandler = (evt: Event) => {
      evt.stopPropagation();
      searchlimiter(obj, (evt.target as HTMLInputElement).value);
    };

    input.addEventListener('keyup', keyHandler);
    input.addEventListener('keydown', keyHandler);
    input.addEventListener('change', changeHandler);

    input.value = lastSearch;
    input.focus();
  }

  // Handle endintoview event
  obj.addEventListener('endintoview', function(evt: Event){
    nextlimiter(evt.target as HTMLElement);
  });

  search(obj, lastSearch);
}